webpackJsonp([1],{

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  repo: 'blog', // required
  owner: 'fouber', // required
  title: 'fouber blog',
  token: '04e8b93ee29f73017d82f01f217e3d#07b261#ebcb', // required. split your access_token with #, create in https://github.com/settings/tokens
  perPage: '15',
  social: [{
    name: 'github',
    url: ''
  }, {
    name: 'weibo',
    url: ''
  }, {
    name: 'twitter',
    url: ''
  }, {
    name: 'wechat',
    url: ''
  }, {
    name: 'instagram',
    url: ''
  }, {
    name: 'facebook',
    url: ''
  }]
});

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(125);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ajax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPostApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIndexApi; });




var token = __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].token.split('#').join('');

var ajax = function ajax(url, cb) {
  __WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.inc();
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
    cb && cb(response);
    __WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.done();
  }).catch(function (error) {
    __WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.done();
    console.log(error);
  });
};

var getPostApi = function getPostApi(id) {
  return 'https://api.github.com/repos/' + __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].owner + '/' + __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].repo + '/issues/' + id + '?access_token=' + token;
};

var getIndexApi = function getIndexApi(page) {
  return 'https://api.github.com/repos/' + __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].owner + '/' + __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].repo + '/issues?page=' + page + '&per_page=' + __WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].perPage + '&filter=created&access_token=' + token;
};

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_App__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Index__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Post__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_moment__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_3_components_Index___default.a
  }, {
    path: '/post/:id',
    name: 'post',
    component: __WEBPACK_IMPORTED_MODULE_4_components_Post___default.a
  }]
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2_components_App___default.a);
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)
__webpack_require__(162)
__webpack_require__(163)
__webpack_require__(159)
__webpack_require__(160)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 153:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', {
    staticClass: "links"
  }, _vm._l((_vm.social), function(item) {
    return _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('i', {
      class: ("fa fa-" + (item.name))
    })])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.body),
      expression: "body"
    }],
    staticClass: "post"
  }, [_c('h4', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.issue.created_at, "MMM DD, YYYY")) + " By "), _c('a', {
    attrs: {
      "href": _vm.issue.user.html_url
    }
  }, [_vm._v(_vm._s(_vm.issue.user.login))])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.issue.title))]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.issues), function(issue) {
    return _c('li', [_c('h3', {
      staticClass: "created-at"
    }, [_vm._v(_vm._s(_vm._f("moment")(issue.created_at, "MMM DD, YYYY")))]), _vm._v(" "), _c('h2', [_c('router-link', {
      attrs: {
        "to": ("/post/" + (issue.number))
      }
    }, [_vm._v(_vm._s(issue.title))])], 1)])
  })), _vm._v(" "), (_vm.isEmpty) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Empty")]) : _vm._e(), _vm._v(" "), _c('pager', {
    attrs: {
      "onChange": _vm.cb,
      "prevVisible": _vm.prevVisible,
      "nextVisible": _vm.nextVisible
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vheader'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer text-center"
  }, [_c('p', [_c('span', [_vm._v("theme based on ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://blog.evanyou.me/"
    }
  }, [_vm._v("blog.evanyou.me")]), _vm._v(" "), _c('span', [_vm._v("| proudly powered by")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/sinchang/sublog"
    }
  }, [_vm._v("sublog")])])])
}]}

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.prevVisible),
      expression: "prevVisible"
    }],
    staticClass: "blog-nav",
    attrs: {
      "id": "prev",
      "href": "javascript:;"
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("< PREV")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nextVisible),
      expression: "nextVisible"
    }],
    staticClass: "blog-nav",
    attrs: {
      "id": "next",
      "href": "javascript:;"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("NEXT >")])])
},staticRenderFns: []}

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 9,
	"./af.js": 9,
	"./ar": 16,
	"./ar-dz": 10,
	"./ar-dz.js": 10,
	"./ar-kw": 11,
	"./ar-kw.js": 11,
	"./ar-ly": 12,
	"./ar-ly.js": 12,
	"./ar-ma": 13,
	"./ar-ma.js": 13,
	"./ar-sa": 14,
	"./ar-sa.js": 14,
	"./ar-tn": 15,
	"./ar-tn.js": 15,
	"./ar.js": 16,
	"./az": 17,
	"./az.js": 17,
	"./be": 18,
	"./be.js": 18,
	"./bg": 19,
	"./bg.js": 19,
	"./bn": 20,
	"./bn.js": 20,
	"./bo": 21,
	"./bo.js": 21,
	"./br": 22,
	"./br.js": 22,
	"./bs": 23,
	"./bs.js": 23,
	"./ca": 24,
	"./ca.js": 24,
	"./cs": 25,
	"./cs.js": 25,
	"./cv": 26,
	"./cv.js": 26,
	"./cy": 27,
	"./cy.js": 27,
	"./da": 28,
	"./da.js": 28,
	"./de": 31,
	"./de-at": 29,
	"./de-at.js": 29,
	"./de-ch": 30,
	"./de-ch.js": 30,
	"./de.js": 31,
	"./dv": 32,
	"./dv.js": 32,
	"./el": 33,
	"./el.js": 33,
	"./en-au": 34,
	"./en-au.js": 34,
	"./en-ca": 35,
	"./en-ca.js": 35,
	"./en-gb": 36,
	"./en-gb.js": 36,
	"./en-ie": 37,
	"./en-ie.js": 37,
	"./en-nz": 38,
	"./en-nz.js": 38,
	"./eo": 39,
	"./eo.js": 39,
	"./es": 41,
	"./es-do": 40,
	"./es-do.js": 40,
	"./es.js": 41,
	"./et": 42,
	"./et.js": 42,
	"./eu": 43,
	"./eu.js": 43,
	"./fa": 44,
	"./fa.js": 44,
	"./fi": 45,
	"./fi.js": 45,
	"./fo": 46,
	"./fo.js": 46,
	"./fr": 49,
	"./fr-ca": 47,
	"./fr-ca.js": 47,
	"./fr-ch": 48,
	"./fr-ch.js": 48,
	"./fr.js": 49,
	"./fy": 50,
	"./fy.js": 50,
	"./gd": 51,
	"./gd.js": 51,
	"./gl": 52,
	"./gl.js": 52,
	"./gom-latn": 53,
	"./gom-latn.js": 53,
	"./he": 54,
	"./he.js": 54,
	"./hi": 55,
	"./hi.js": 55,
	"./hr": 56,
	"./hr.js": 56,
	"./hu": 57,
	"./hu.js": 57,
	"./hy-am": 58,
	"./hy-am.js": 58,
	"./id": 59,
	"./id.js": 59,
	"./is": 60,
	"./is.js": 60,
	"./it": 61,
	"./it.js": 61,
	"./ja": 62,
	"./ja.js": 62,
	"./jv": 63,
	"./jv.js": 63,
	"./ka": 64,
	"./ka.js": 64,
	"./kk": 65,
	"./kk.js": 65,
	"./km": 66,
	"./km.js": 66,
	"./kn": 67,
	"./kn.js": 67,
	"./ko": 68,
	"./ko.js": 68,
	"./ky": 69,
	"./ky.js": 69,
	"./lb": 70,
	"./lb.js": 70,
	"./lo": 71,
	"./lo.js": 71,
	"./lt": 72,
	"./lt.js": 72,
	"./lv": 73,
	"./lv.js": 73,
	"./me": 74,
	"./me.js": 74,
	"./mi": 75,
	"./mi.js": 75,
	"./mk": 76,
	"./mk.js": 76,
	"./ml": 77,
	"./ml.js": 77,
	"./mr": 78,
	"./mr.js": 78,
	"./ms": 80,
	"./ms-my": 79,
	"./ms-my.js": 79,
	"./ms.js": 80,
	"./my": 81,
	"./my.js": 81,
	"./nb": 82,
	"./nb.js": 82,
	"./ne": 83,
	"./ne.js": 83,
	"./nl": 85,
	"./nl-be": 84,
	"./nl-be.js": 84,
	"./nl.js": 85,
	"./nn": 86,
	"./nn.js": 86,
	"./pa-in": 87,
	"./pa-in.js": 87,
	"./pl": 88,
	"./pl.js": 88,
	"./pt": 90,
	"./pt-br": 89,
	"./pt-br.js": 89,
	"./pt.js": 90,
	"./ro": 91,
	"./ro.js": 91,
	"./ru": 92,
	"./ru.js": 92,
	"./sd": 93,
	"./sd.js": 93,
	"./se": 94,
	"./se.js": 94,
	"./si": 95,
	"./si.js": 95,
	"./sk": 96,
	"./sk.js": 96,
	"./sl": 97,
	"./sl.js": 97,
	"./sq": 98,
	"./sq.js": 98,
	"./sr": 100,
	"./sr-cyrl": 99,
	"./sr-cyrl.js": 99,
	"./sr.js": 100,
	"./ss": 101,
	"./ss.js": 101,
	"./sv": 102,
	"./sv.js": 102,
	"./sw": 103,
	"./sw.js": 103,
	"./ta": 104,
	"./ta.js": 104,
	"./te": 105,
	"./te.js": 105,
	"./tet": 106,
	"./tet.js": 106,
	"./th": 107,
	"./th.js": 107,
	"./tl-ph": 108,
	"./tl-ph.js": 108,
	"./tlh": 109,
	"./tlh.js": 109,
	"./tr": 110,
	"./tr.js": 110,
	"./tzl": 111,
	"./tzl.js": 111,
	"./tzm": 113,
	"./tzm-latn": 112,
	"./tzm-latn.js": 112,
	"./tzm.js": 113,
	"./uk": 114,
	"./uk.js": 114,
	"./ur": 115,
	"./ur.js": 115,
	"./uz": 117,
	"./uz-latn": 116,
	"./uz-latn.js": 116,
	"./uz.js": 117,
	"./vi": 118,
	"./vi.js": 118,
	"./x-pseudo": 119,
	"./x-pseudo.js": 119,
	"./yo": 120,
	"./yo.js": 120,
	"./zh-cn": 121,
	"./zh-cn.js": 121,
	"./zh-hk": 122,
	"./zh-hk.js": 122,
	"./zh-tw": 123,
	"./zh-tw.js": 123
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Vheader: __WEBPACK_IMPORTED_MODULE_0__Header___default.a
  }
});

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(125);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-header',
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].title,
      social: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].social
    };
  }
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pager__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Pager__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  data: function data() {
    return {
      issues: [],
      page: 1,
      isEmpty: false,
      prevVisible: false,
      nextVisible: true
    };
  },
  created: function created() {
    this.fetchIssues(this.page);
  },

  methods: {
    fetchIssues: function fetchIssues(page) {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["a" /* ajax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["c" /* getIndexApi */])(page), function (res) {
        if (res.data.length === 0) {
          _this.isEmpty = true;
          _this.nextVisible = false;
          _this.issues = [];
          return;
        }
        _this.isEmpty = false;
        _this.nextVisible = true;
        _this.issues = res.data;
      });
    },
    cb: function cb(page) {
      if (page === 1) {
        this.prevVisible = false;
      } else {
        this.prevVisible = true;
      }
      this.page = page;
      this.fetchIssues(this.page);
    }
  },
  components: {
    Pager: __WEBPACK_IMPORTED_MODULE_1__Pager___default.a
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pager',
  data: function data() {
    return {
      page: 1
    };
  },

  props: {
    onChange: {
      type: Function
    },
    prevVisible: {
      type: Boolean
    },
    nextVisible: {
      type: Boolean
    }
  },
  methods: {
    prev: function prev() {
      this.page--;
      this.onChange(this.page);
      window.scroll(0, 0);
    },
    next: function next() {
      this.page++;
      this.onChange(this.page);
      window.scroll(0, 0);
    }
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post',
  data: function data() {
    return {
      issue: {},
      body: ''
    };
  },
  created: function created() {
    this.fetchSingleIssue();
  },

  methods: {
    fetchSingleIssue: function fetchSingleIssue() {
      var _this = this;

      this.issue = {};
      this.body = '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["a" /* ajax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["b" /* getPostApi */])(this.$route.params.id), function (res) {
        _this.issue = res.data;
        _this.body = __WEBPACK_IMPORTED_MODULE_1_marked___default()(res.data.body);
      });
    }
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(127);


/***/ })

},[173]);


// WEBPACK FOOTER //
// client.b6b72295.js